import { Frequency } from 'rrule';
import { expandRecurrenceInstants } from '@bt-common/utils/recurrence-calculations';
import { ruleOptionsFromString } from './recurrence-utils';

/**
 * FE#470: moving the frequency dropdown from Day/Week to Month/Year clears the
 * weekday set, so a rule that fired every day now fires once a month or a year,
 * and the dialog said nothing. This is the check behind the notice that says so,
 * with the date of the next send.
 */
export interface CadenceDropWarning {
    unit: 'month' | 'year';
    /** The first send after the chosen start under the new rule. */
    next: Date;
}

export const cadenceDropWarning = (input: {
    /** The rule the series had when the popover opened; none for a brand-new rule. */
    originalRrule: string | undefined;
    /** The rule as currently drafted in the popover. */
    draftRrule: string | undefined;
    /** Real instant the next send must follow (the chosen start). */
    after: Date;
    tzid?: string;
}): CadenceDropWarning | null => {
    const { originalRrule, draftRrule, after, tzid } = input;
    if (!originalRrule || !draftRrule) return null;
    try {
        const original = ruleOptionsFromString(originalRrule);
        const draft = ruleOptionsFromString(draftRrule);
        const wasFrequent = original.freq === Frequency.DAILY || original.freq === Frequency.WEEKLY;
        const unit = draft.freq === Frequency.YEARLY ? 'year' : draft.freq === Frequency.MONTHLY ? 'month' : null;
        if (!wasFrequent || !unit) return null;
        const [next] = expandRecurrenceInstants(draftRrule, tzid, { after, count: 1 });
        return next ? { unit, next } : null;
    } catch {
        return null;
    }
};
